import { cn } from '../../lib/cn';
import { Card } from '../ui';

type Item = { id: string; label: string; count?: number; active?: boolean };

type Props = {
  title?: string;
  items?: Item[];
  favorites?: string[];
  onSelect?: (id: string) => void;
  className?: string;
};

const DEFAULT_ITEMS: Item[] = [
  { id: 'all', label: 'All Items', count: 142, active: true },
  { id: 'active', label: 'Active', count: 128 },
  { id: 'draft', label: 'Draft', count: 8 },
  { id: 'archived', label: 'Archived', count: 6 },
];

export function ExplorerPanel({
  title = 'Explorer',
  items = DEFAULT_ITEMS,
  favorites = ['SP-EARBUDS-BRAND', 'CASE-PRO'],
  onSelect,
  className,
}: Props) {
  return (
    <Card className={cn('h-full', className)} padding="sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{title}</p>
      <ul className="mt-3 space-y-1">
        {items.map((item) => (
          <li key={item.id}>
            <button
              type="button"
              onClick={() => onSelect?.(item.id)}
              className={cn(
                'flex w-full items-center justify-between rounded-md px-2 py-1.5 text-left text-sm',
                item.active ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' : 'text-slate-600 hover:bg-slate-50 dark:text-slate-400 dark:hover:bg-slate-800',
              )}
            >
              <span>{item.label}</span>
              {item.count != null && <span className="text-xs text-slate-400">{item.count}</span>}
            </button>
          </li>
        ))}
      </ul>
      {favorites.length > 0 && (
        <div className="mt-4 border-t border-slate-200 pt-3 dark:border-slate-700">
          <p className="text-xs font-medium text-slate-500">Pinned</p>
          <ul className="mt-2 space-y-1">
            {favorites.map((f) => (
              <li key={f} className="truncate px-2 text-xs text-slate-600 dark:text-slate-400">{f}</li>
            ))}
          </ul>
        </div>
      )}
    </Card>
  );
}
